<template>
	<div class="login_header">
		<div class="login_header_wrap">
			
		</div>
		<el-form @submit.prevent="submit" :model="formData" :rules="rules">
			<div class="login-content-wrap">
				<div class="login-content-wrap-col">
					<div class="login-content">
						<div class="login-content-title">
							<h1>注册</h1>
						</div>
						<div class="login-content-item">
							<div class="login-contents">
								<el-select v-model="formData.role" clearable placeholder="请选择注册类型" @change="setRole()">
									<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.label" style="padding-left: 35px">
								</el-option>
							</el-select>
							<i slot="prefix" class="el-input__icon el-icon-office-building input_icon"></i>    
						</div>
						<div class="login-contents">
							<el-form-item prop="user_id">
								<el-input  v-model="formData.user_id" name="user_name" autocomplete="off"  placeholder="请输入账号">
									<i slot="prefix" class="el-input__icon el-icon-user input_icon"></i>
								</el-input>
							</el-form-item>
						</div>
						<div class="login-contents">
							<!-- <p>Email*</p> -->
							<input placeholder="   请输入 公司名" v-model="formData.companyName">
							<i slot="prefix" class="el-input__icon el-icon-document input_icon"></i>
						</div>
						<div class="login-contents">
							<!-- <p>Email*</p> -->
							<input placeholder="   请输入 公司地址" v-model="formData.address">
							<i slot="prefix" class="el-input__icon el-icon-document input_icon"></i>
						</div>
						<div class="login-contents">
							<!-- <p>Email*</p> -->
							<input type="email" name="email" placeholder="   请输入 email" v-model="formData.email">
							<i slot="prefix" class="el-input__icon el-icon-document input_icon"></i>
						</div>
						<div class="login-contents">
							<!--  <p>电话*</p> -->
							<input type="phone" name="phone" placeholder="   请输入手机号码" v-model="formData.phone">
							<i slot="prefix" class="el-input__icon el-icon-phone-outline input_icon"></i>
						</div>
						<div class="login-contents">
							<!-- <p>密码*</p> -->
							<input type="text"  placeholder="   请输入姓名" v-model="formData.user_name">
							<i slot="prefix" class="el-input__icon el-icon-place input_icon"></i>
						</div>
						<div class="login-contents">
							<!-- <p>密码*</p> -->
							<input type="password" name="password" placeholder="   请输入密码" v-model="formData.password">
							<i slot="prefix" class="el-input__icon el-icon-lock input_icon"></i>
						</div>
					   <!--  <div class="login-contents">
						    <p>确认密码*</p>
						    <input type="password" name="password2" placeholder="   再次输入密码" v-model="formData.password2">
						</div> -->
						<div class="login-contents">
							<div class="checkbox">
								<input name="Checkbox" type="checkbox" id="agree"/>
								<label>我同意 <a href="#">使用条款</a></label>
							</div>
						</div>
						<div class="login-contents" >
							<div class="login-btn signUp" >

								<input  value="注册" @click="submit()" class="login"  />
							</div>
						</div>
						<div class="login-contents">
							<p>已经有帐号？<a href="login">登录</a></p>
						</div>	
					</div>

				</div>
			</div>
		</div>
	</el-form>

</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
		name:'Login',
		data(){
			return {
				formData:{
					user_id:'',
					user_name:'',
					email:'',
					phone:'',
					password:'',
					password2:'',
					role: ''
				},
				options: [{
					value: '选项1',
					label: '模具厂'
				}, {
					value: '选项2',
					label: '模具买家'
				}, {
					value: '选项3',
					label: '加工点'
				}, {
					value: '选项4',
					label: '机床配件供应链'
				}],
				rules:{
				user_id:
				[
					{required:true,message:'请输入账号',trigger:'blur'},
					{min: 3, max: 11, message: '长度在 3 到 11 个字符', trigger: 'blur' }
				],
				password:[
					{required:true,message:'请输入密码',trigger:'blur'},
					{min: 3, max: 11, message: '长度在 3 到 11 个字符', trigger: 'blur' }
				],
				phone:[
					{required:true,message:'请输入手机号码',trigger:'blur'},
					{min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }
				],
				}
				
			}
		},
		methods:{
			...mapActions(['Signup']),
			submit(e) { 		
				let _this = this;
				console.log(this.formData)
				this.Signup(this.formData).then(res => {
					alert("注册成功") 
				 window.location.href="https://open.weixin.qq.com/connect/qrconnect?appid=wx5faeeda683cee8cc&redirect_uri=https%3A%2F%2Fwww.2mould.com/WxRegister&response_type=code&scope=snsapi_login&state=" + res.data
			}).catch(error => {
				console.log(error)
				alert(error.body.msg + '失败' + error.body.data + "重复")
			}).finally(() =>{
				console.log("sda")
			})

			// this.$http.post('/yungc/Register',{formData:this.formData})
			// .then(res =>{
			// 	alert("注册成功")
			// 	this.$router.push({ path:'/login'  })
			// }).catch(error =>{
			// 	if(error.status == 604){
			// 		console.log(error)
			// 		alert(error.body.msg + '失败' + error.body.data + "重复")
			// 	}
			// })
			//this.Login().then
		},
		istest(){
			console.log(1);
		},
		setRole(){
			console.log(this.role)
		}
	},
	created(){

	},
	mounted(){

	}


}

</script>

<style scoped>
*{ padding:0; margin:0; list-style:none; box-sizing: border-box;}
html{font-size: 50px;height: 100%;}
body{font-family:arial; font-size:14px;color:#000000;height: 100%;}
a{color:#666;text-decoration:none;}
a:hover{text-decoration: none;}
img{border:0;max-width: 100%;vertical-align: middle;}
i{    position: absolute;
	left: 5px;}
	form{    margin-top: 20px;}
	.login-contents >>> .el-input__inner{padding-left: 35px!important;height: 34px;line-height: 34px;width: 350px;font-size: 12px;color: #606266;}
	.el-select-dropdown__item{font-size: 12px;}
	.el-input__inner{padding-left: 35px;height: 34px;line-height: 34px;}
		._flex{display: flex;display: -ms-flexbox;display: -webkit-flex;}
		.clear{clear:both;}
		.icon {width: 1em; height: 1em;vertical-align: -0.15em;fill: currentColor;overflow: hidden;}
		.wid{ width:1400px; margin:0 auto;}
		.wid:after{ content:""; display:block; clear:both;}
		.mid{ width:1200px; margin:0 auto;padding:0 2%;box-sizing: border-box;}
		.mid:after{ content:""; display:block; clear:both;}
		.sid{width: 1100px!important;margin:0 auto;}
		.sid:after{content:""; display:block; clear:both;}
		.act{background: #c62430;color: white!important;}


		.header_wrap{display: flex; justify-content: space-between; align-items: center; background: #000000; color: #fff; height: 64px; padding: 0 30px;}
		.nav{height: 100%;}
		.nav a{color: #fff; display: inline-block; padding: 6px 20px; border-bottom: 2px solid transparent;line-height: 32px; padding-top: 16px;}
		.nav a:hover{border-bottom: 2px solid #5252f2;}
		.btn a{display: inline-block; background: #1a1a1a; padding: 9px 18px; color: #fff; border-radius: 4px;}
		.btn a:nth-child(2){background: #5252f2;}
		.btn a:hover{background: #262626;}
		.btn a:hover:nth-child(2){background: #2d208c;}
		.btn img{width: 32px; align-items: center;}

		.content{background: #000000;color: #FFFFFF;align-items: center;}
		.content1{padding: 40px 80px;background-color: #000000;}
		.content1-left {float: left;width: 50%;padding: 40px 40px;}
		.content1-left h1{font-size:48px;padding: 10px 60px;margin:50px 80px 0 0}
		.content1-left h2{font-size:20px;color:#9e9e9e;padding: 10px 60px;margin:10px 100px 0 0}
		.content1-left-btn a{display: inline-block;font-size:18px;background: #5252f2;color:#FFFFFF;padding:15px 32px;margin:35px 0 35px 60px;border-radius: 4px;}
		.content1-left-btn a:nth-child(2){background: #1a1a1a;margin:35px 0 35px 60px;}
		.content1-left-btn img{display: inline-block;width: 80%;margin: 10px 0 0 40px;}
		.content1-right {float: right; width: 50%; align-items: center;} 
		.content1-right img{width: 100%;}
		.content1-trusted {text-align: center;}
		.content1-trusted h1{font-size:16px;color:#a8a8a8;padding: 20px 0;}

		.video {text-align: center;background: #000000;}

		.content-capability {background: #000000;color: #FFFFFF;text-align: center;padding:50px 50px}
		.content-capability h1{font-size: 36px;padding: 30px 0 10px 0;}
		.content-capability-btn a{display: inline-block;font-size:14px;background: #1A1A1A;color:#FFFFFF;padding: 10px 16px;margin: 0 30px 50px 30px;border-radius: 4px;margin: 10px 30px 50px 30px;}
		.content-capability-wrap {display: flex; justify-content: space-around;}
		.content-capabilities {width: 328px;background-color: #181818;}
		.content-capabilities img{width: 100%;}
		.content-capabilities h1{font-size: 24px;padding: 20px 20px;margin: 10px 10px;height: 124px;}
		.content-capabilities h2{font-size: 16px;padding: 20px 20px;margin: 10px 10px;color: #A8A8A8;}
		.content-capabilities a{font-size:14px;background: #5252f2;color:#FFFFFF;padding: 15px 15px;border-radius: 4px;display:block;margin: 20px 40px;}
		.content-capabilities a:last-of-type{background: #313131;}

		.content-businesses{background: #191919;color: #FFFFFF;text-align: center;padding:40px 50px;}
		.content-businesses-title {margin: 30px 0;}
		.content-businesses-title h1{font-size: 36px;padding: 30px 0 30px 0;}
		.content-testimonial-body-wrap {display: flex;justify-content: space-around;}
		.content-testimonial-body {width: 352px;}
		.content-testimonial-body p{font-size: 20px;}
		.content-testimonial-body img{width: 50%;}
		.login_header{
			height: 100%;
			background-color: #eceef1;
			background-image: url('../assets/images/login_back.jpg');
			background-repeat: no-repeat;
			background-size: cover;
			text-align: center;
		}
		.login_header_wrap {display: flex;justify-content: space-between; height: 64px;padding: 0 30px;
		}
		.login-header-left {display: flex;align-items: center;width: 226px;}
		.login-header-left img{height:50px;margin: 0 10px;}
		.login-header-left h1{font-size: 16px;margin: 0 20px;color: #3b3b3b;}
		.login-header-right {display:flex;align-items: center;font-size: 16px;}
		.login-header-right a{color:#2c0606;margin: 0 20px;}
		.login-content-wrap {height: 80%;position: relative;
			padding: 0 100px;
			display: inline-block;
			text-align: left;}
			.login-content-wrap-col{
				width: 350px;
				background: #fff;
				padding: 20px 30px 10px 30px!important;
				box-sizing: content-box;
				z-index: 9;
				position: relative;
				border-radius: 6px;
			}
			.login-content {margin-top: 0px;width: 350px;}
			.login-content-item{
				display: flex;justify-content: space-between;flex-wrap: wrap;
			}
			.login-content-title h1{font-size: 26px;
				color: #000;
				margin: 0 auto 10px auto;
				text-align: center;
				font-weight: 700;}
				.login-contents {line-height: 40px;
					position: relative;
					font-size: 12px;
					width: 100%;
					margin-bottom: 15px;
					position: relative;
				}
				.login-contents p{text-align: left;margin-bottom: 4px;}
				.login-contents input{
					background-color: #fff;
					background-image: none;
					border-radius: 4px;
					border: 1px solid #dcdfe6;
					box-sizing: border-box;
					color: #606266;
					display: inline-block;
					font-size: inherit;
					height: 34px;
					line-height: 34px;
					outline: 0;
					padding: 0 25px;
					transition: border-color .2s cubic-bezier(.645,.045,.355,1);
					width: 100%;}
					.login-contents input:hover{border-color:#3463c0;}
					.login-contents a{color: #5252F2;}
					.login-btn a{display: block;padding: 10px 0;justify-content: center;text-align: center; background-color: #5252F2;color: #FFFFFF;border-radius: 4px;}
					.login-btn input{display: block;justify-content: center;text-align: center; background-color: #0051a4;color: #FFFFFF;border-radius: 4px;}
					.checkbox {display: flex;}
					.checkbox input{width: 20px;height: 20px;margin: 10px 10px 0 0;}

					.injection-top-wrap {height: 500px;display: flex;justify-content: space-around;align-items: center;padding: 0 200px;}
					.injection-top-title {font-size: 20px;padding: 0 30px;}
					.injection-top-title p{padding: 10px 20px;}
					.injection-top-title p:first-child{font-size: 48px;text-align: center;}
					.injection-top-title ul{margin: 10px 20px;padding: 20px 0;}
					.injection-top-title a{font-size: 18px;width: 38px;padding: 15px 32px;background-color: #5252F2;color: #FFFFFF;border-radius: 4px;margin: 10px 20px;}
					.injection-top-wrap img{width: 540px;padding: 0 15px;}

					.injection-materials {display: flex;justify-content: space-around; flex-direction: column;padding: 50px 20px;margin: 0 200px;font-size: 18px;}
					.injection-materials h2{font-size: 40px;text-align: center;margin: 20px 0;}
					.injection-materials-top p{padding: 20px 0;color: #A8A8A8;width: 770px;margin: 0 auto;}
					.injection-materials-plastics-a {width: 770px; display: flex;justify-content: space-between;margin: 20px auto;}
					.injection-materials-plastics-a a{background-color:#313131;color: #FFFFFF;border-radius: 4px;padding: 10px 15px;}
					.injection-materials-Plastics-top {display: flex;justify-content: space-between;}
					.injection-materials-Plastics-Rigid {background-color: #191919;width:100%; margin: 0 auto;padding: 16px 50px;margin: 20px 0;}
					.injection-materials-Plastics-Rigid h3{font-size: 28px;margin-top: 20px;}
					.injection-materials-Plastics-Rigid p{padding: 20px 0;color: #A8A8A8;width: 770px;margin: 0 auto;}
					.injection-materials-Subtypes-title {padding: 10px 0;color: #A8A8A8;}
					.injection-materials-Subtypes-content {display: flex;justify-content: space-around;}
					.injection-materials-Subtypes-ul li{font-family:STHeiti;font-size: 16px;}
				</style>